// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__mkw0U","sidebar__wrapper":"Sidebar_sidebar__wrapper__rUh2h","sidebar__support":"Sidebar_sidebar__support__tr4fa"};